import React, { FC } from 'react';
import { ArticleInfographicBlock as Data } from '../../../graphql/generated/api-graphql';
import InfographieBlock, { InfographieBlockProps } from '../../../components/molecules/InfographieBlock';
import { wediaImagesTransform } from '../../Common/wedia';
import { HtmlLayout } from '../../../components/atoms/Html/types';
export type ArticleInfographicBlockProps = {
  data: Data & {
    anchor: string;
  };
};
const ArticleInfographicBlock: FC<ArticleInfographicBlockProps> = ({
  data
}) => {
  // console.log(
  //   'src/relay/ArticleBlocks/ArticleInfographicBlock/index.tsx, data',
  //   data
  // )

  const props: InfographieBlockProps = {
    introduction: data?.text ? {
      text: data.text,
      layout: HtmlLayout.article
    } : undefined,
    title: data?.title ?? undefined,
    anchor: data.anchor,
    description: data?.description ? {
      text: data.description,
      layout: HtmlLayout.article
    } : undefined,
    mobilePicture: data?.imageMobile ? {
      withHD: true,
      alt: data?.imageMobile?.alt ?? '',
      images: wediaImagesTransform(data?.imageMobile)
    } : undefined,
    tabletPicture: data?.imageTablet ? {
      withHD: true,
      alt: data?.imageTablet?.alt ?? '',
      images: wediaImagesTransform(data?.imageTablet)
    } : undefined,
    desktopPicture: data?.imageDesktop ? {
      withHD: true,
      alt: data?.imageDesktop?.alt ?? '',
      images: wediaImagesTransform(data?.imageDesktop)
    } : undefined,
    legend: data?.legend ?? undefined
  };
  return <InfographieBlock {...props} />;
};
export default ArticleInfographicBlock;